<div class="p-4">
    <div class="mb-3 d-flex justify-content-end">
        <!-- <p *ngIf="!data.quizVideo" class="mulish-bold text-sm">{{movieData['description']}}</p> -->
            <img class="c-pointer" src="assets/images/close-movie.svg" alt="" (click)="close()">
    </div>
      <div class='video-wrapper'> 
        <iframe *ngIf="!data.quizVideo"  height="100%" width="100%" style="display: iframe;"
        [src]="movieData['link'] +'?autoplay=1' | safe" frameborder="0" allow='autoplay;' allowfullscreen>
         </iframe>
         <iframe *ngIf="data.quizVideo"  height="100%" width="100%" style="display: iframe;"
        [src]="movieData +'?autoplay=1' | safe" frameborder="0" allow='autoplay;' allowfullscreen>
         </iframe>
      </div> 
    <!-- <div class="col-12" *ngIf="!data.quizVideo && descriptionContent ">
        <p class="mulish-normal text-xs">Bhutan, one of the two new destinations from Global Exploration sinds 2019, belongs to one of the most closed countries in the world. It was not open for tourists until 1974 at all. It's up to the Bhutan group..</p>

    </div>
    <div class="col-12 " *ngIf="!data.quizVideo && movieData['sdg_ids']?.length>0 && false">
        <p class="mulish-bold text-xxs mt-2">
          <a class="text-danger pointer-cursor" (click)="showAllVideosInSdg()">
            {{"SEE ALL VIDEOS FROM" | translate}} <span >{{movieSdg[0]['name'] | uppercase}}</span>
          </a>
        </p>
    </div> -->


</div>
